const SET_PROJECTS = 'SET_PROJECTS';

export default SET_PROJECTS;
